import * as React from 'react';
import ReadOnlyRecipientViewState from '../store/schema/ReadOnlyRecipientViewState';
import strings from 'owa-strings/owa-common-strings';
import {
    personaCardBehavior,
    PersonaCardBehaviorProps,
} from 'owa-persona/lib/components/PersonaCardBehavior';
import { observer } from 'mobx-react';

const styles = require('./ReadOnlyRecipient.scss');
const classNames = require('classnames');

export interface ReadOnlyRecipientProps extends PersonaCardBehaviorProps {
    viewState: ReadOnlyRecipientViewState;
    renderSelf?: boolean;
    isLast?: boolean;
    onlyShowEmail?: boolean;
    className?: string;
    showPlainText?: boolean;
}

interface ReadOnlyRecipientWithPeronaCardBehaviorProps extends ReadOnlyRecipientProps {
    recipientContent: string;
    recipientContentClassName: string;
}

@observer
export default class ReadOnlyRecipient extends React.Component<ReadOnlyRecipientProps, any> {
    render(): any {
        let recipientContent;
        if (this.props.onlyShowEmail) {
            recipientContent = this.props.viewState.email.EmailAddress;
        } else {
            recipientContent = this.props.renderSelf
                ? strings.recipientSelf
                : this.props.viewState.email.Name || this.props.viewState.email.EmailAddress;
            if (this.props.viewState.showFullEmail) {
                recipientContent += ' <' + this.props.viewState.email.EmailAddress + '>';
            }
            if (!this.props.isLast) {
                recipientContent += ';';
            }
        }

        recipientContent = ' ' + recipientContent;

        const recipientContentClassName = classNames(
            styles.recipientContent,
            this.props.className,
            this.props.viewState.isGroupOrDl ? styles.groupOrDl : null
        );

        return this.props.showPlainText ? (
            <div className={recipientContentClassName}>{recipientContent}</div>
        ) : (
            <ReadOnlyRecipientWithPeronaCardBehavior
                {...this.props}
                recipientContent={recipientContent}
                recipientContentClassName={recipientContentClassName}
            />
        );
    }
}

@personaCardBehavior
@observer
class ReadOnlyRecipientWithPeronaCardBehavior extends React.Component<
    ReadOnlyRecipientWithPeronaCardBehaviorProps,
    any
> {
    render(): any {
        return (
            <div
                className={this.props.recipientContentClassName}
                onClick={this.props.onPersonaCardBehaviorClick}
                onMouseEnter={this.props.onPersonaCardBehaviorMouseEnter}
                onMouseLeave={this.props.onPersonaCardBehaviorMouseLeave}>
                {this.props.recipientContent}
            </div>
        );
    }
}
